var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 5.04818e-06C17.1965 -0.00146756 18.8147 0.319256 20.3245 0.943827C21.8344 1.5684 23.2063 2.48454 24.3617 3.63986C25.5171 4.79517 26.4333 6.16695 27.0579 7.67672C27.6825 9.18649 28.0032 10.8046 28.0018 12.4385H15.5625V5.04818e-06Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4616 15.5286V3.10132C9.99768 3.09911 7.58852 3.82791 5.53909 5.19554C3.48967 6.56317 1.89225 8.50813 0.948846 10.7841C0.00544326 13.0601 -0.241457 15.5648 0.2395 17.9811C0.720456 20.3975 1.90762 22.6168 3.65065 24.3582C5.39367 26.0995 7.61414 27.2846 10.0311 27.7633C12.448 28.2421 14.9527 27.993 17.228 27.0476C19.5033 26.1022 21.4468 24.5031 22.8127 22.4525C24.1786 20.402 24.9053 17.9923 24.9008 15.5286H12.4616Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 5.04818e-06C17.1965 -0.00146756 18.8147 0.319256 20.3245 0.943827C21.8344 1.5684 23.2063 2.48454 24.3617 3.63986C25.5171 4.79517 26.4333 6.16695 27.0579 7.67672C27.6825 9.18649 28.0032 10.8046 28.0018 12.4385H15.5625V5.04818e-06Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphs);
export default __webpack_public_path__ + "static/media/graphs.49a7ff7a6f4cd6d5453a8a5cde0002a8.svg";
export { ForwardRef as ReactComponent };